module.exports = __webpack_public_path__ + "static/media/play-lamp-right.e6800a3f.png";